<div class="flex flex-col gap-8">

  <div class="flex flex-col gap-4">
    <div class="ec-category-header">
      {{ 'dashboard.overview.meteringpoints.title' | translate }}
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
      <app-status-card [config]="meteringPointProductionObligation"></app-status-card>
      <app-status-card [config]="meteringPointWithSupplier"></app-status-card>
      <app-status-card [config]="meteringPointChargeInformationRejected"></app-status-card>
      <app-status-card [config]="meteringPointChargeInformationPending"></app-status-card>
      <app-status-card [config]="meteringPointOverduePending"></app-status-card>
      <app-status-card [config]="meteringPointRejectedByDataHub"></app-status-card>
      <app-status-card [config]="meteringPointGhostMeters"></app-status-card>
      <app-status-card [config]="meteringPointNotInDHM"></app-status-card>
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <div class="ec-category-header">
      {{ 'dashboard.overview.dataconsistency.title' | translate }}
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
      <app-status-card [config]="meteringPointNoMeter"></app-status-card>
      <app-status-card [config]="meteringPointVirtualNoCalculation"></app-status-card>
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <div class="ec-category-header">
      {{ 'dashboard.overview.electricalheating.title' | translate }}
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
      <app-status-card [config]="electricalHeatingCreate"></app-status-card>
      <app-status-card [config]="electricalHeatingRemove"></app-status-card>
    </div>
  </div>

</div>
